// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_footer.styl
// module id = 154
// module chunks = 0